import { Column, ColumnKeys } from './grid';
import { GridViewMetadata } from '../../../grid/gridView/types';
import { Filter } from '../../../grid/gridFilters/types';
import { BehaviorProfilesOutput } from '../../phasrRestrictedProfilesSelector/types';

export interface PhasrRecommendationsWebComponentSchema {
  viewMetaData: GridViewMetadata<Column, ColumnKeys>;
  defaultViewProps: DefaultViewProps;
}

export interface DefaultViewProps {
  displayedColumns: Array<Column>;
  filters: Array<Filter<ColumnKeys>>;
  pageSize: number;
  compactView: boolean;
}

export interface PhasrBehavioralProfileIdentitiesResponse {
  behavioralProfileIdentity: string;
  behavioralProfileIdentityName: string;
}

export interface PhasrBehavioralProfileResourcesResponse {
  behavioralProfileResource: string;
  behavioralProfileResourceName: string;
}

export enum PhasrRecommendationsMethod {
  READ_RECORDS = 'readRecordsForCompany',
  GET_PHASR_BEHAVIORAL_PROFILE_IDENTITIES = 'getBehavioralProfileIdentities',
  GET_PHASR_BEHAVIORAL_PROFILE_RESOURCES = 'getBehavioralProfileResources',
  GET_PHASR_BEHAVIORAL_PROFILES_AGGREGATE = 'getBehavioralProfilesAggregate',
  UPDATE_BEHAVIOUR_ACTIONS = 'updateRecommendationBehaviourActions',
  GET_PHASR_RULE_TRIGGERS = 'getRuleTriggers',
  GET_PHASR_INCIDENTS_BY_RULE_ID = 'getIncidentsByRuleId',
  GET_PHASR_BEHAVIORAL_IDENTITIES_AGGREGATE = 'getPhasrProfilesIdentitiesDepartmentAggregate',
}

export enum PhasrRecommendationsEndpoint {
  RECOMMENDATION_STATE = 'CompanyAttackSurfaceReductionRecommendationState',
  BEHAVIORAL_PROFILES = 'BehavioralProfiles',
  RULE_TRIGGERS = 'PhasrRuleTriggers',
}

export interface Dependencies {
  getAvailableCompanies: Function;
  getActiveCompany: Function;
  permissions: Permissions;
  api: {
    clients: {
      Company: {
        getRootOrFirstAvailableCompany: Function;
      };
    };
  };
}

export interface Permissions {
  canHaveChildCompanies: boolean;
}

export enum ErrorCodes {
  COMPANY_DOES_NOT_EXIST_OR_IS_NOT_ACCESSIBLE = 3111,
}

export const RESTRICT_ACTION: ActionType = 1;
export const ALLOW_ACTION: ActionType = 0;
export const UNKNOWN_ACTION: ActionType = 2;

export type ActionType = 0 | 1 | 2;

export enum RecommendationType {
  ALLOW_ACCESS,
  RESTRICT_ACCESS,
}

export interface ApplyRecommendationPayload {
  recommendationId: string;
  ruleId: number;
  companyId: string;
  action: ActionType;
  actionName: string;
  changes: BehaviorProfilesOutput | null;
}

export const OPEN_BEHAVIORAL_PROFILES_PANEL = 'openBehavioralProfilesPanel';
